import { useUploadImageComponent } from "@/erp/tecnico/orden-trabajo/shared/hooks";
import {
  newProspectoSchema, texto, calcularEdad,
  EstadosContribuyenteRucENUM,
  getEnvs,
  ROUTER_PATHS,
} from "@/shared";
import {
  useFetchGetPais,
  useFetchParametros,
  //useFetchSearchIdentification, 
  useFetchSearchIdentificationDirecto
} from "@/shared/actions/erp";
import { useFetchBuroCredito } from "@/shared/actions/erp/global/buro-crediticio";
import { validateSellByOtherUser } from "@/shared/actions/erp/prospecto_corporativo.actions";
import { usePostProspectoPymes } from "@/shared/actions/erp/prospecto_pymes.action";
//import { fetchPostSolicitudDeuda } from "@/shared/actions/erp/solicitud_deuda/solicitud_deuda.actions";
import {
  IFromProspecto, TipoDocumentoNameEnum,
  AlertSeverityEnum, RangoEdadEnum,
  NacionalidadEnum
} from "@/shared/interfaces";
import { useAuthStore } from "@/store/auth";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { isAxiosError } from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

interface IEsCliente { alerta: boolean; nombre: string; linea: number | undefined; plan: string }

const { VITE_NODE_ENV } = getEnvs()
export const useFormProspectoPymes = () => {


  const {
    UploadImageComponent,
    fotoTutorDiscapacidad,
    setFotoTutorDiscapacidad,
    fotoDocumentoLegalRepresentante,
    setFotoDocumentoLegalRepresentante,
    fotoBonoDesarrolloHumano,
    setFotoBonoDesarrolloHumano,
  } = useUploadImageComponent();

  const navigate = useNavigate();

  //USESTATE
  const [disableIdentification, setDisableIdentification] = useState<boolean>(false)
  const [esCliente, setEsCliente] = useState<IEsCliente>({ alerta: false, nombre: '', linea: 0, plan: '' })
  const [esDifunto, setEsDifunto] = useState<boolean>(false)
  const [esResidente, setEsResidente] = useState<boolean>(false)
  /* const [dataProspectoEnEspera, setDataProspectoEnEspera] = useState<IDataProspecto | null>(null)
  const [dataProspectoEnProceso, setDataProspectoEnProceso] = useState<IDataProspecto | null>(null) */
  const [modalProspectoEnEspera, setModalProspectoEnEspera] = useState<boolean>(false)
  const [modalProspectoEnProceso, setModalProspectoEnProceso] = useState<boolean>(false)
  const [aplicaSolicitudBeneficio, setAplicaSolicitudBeneficio] = useState<boolean>(true)
  const [valorRestriccionCel, setValorRestriccionCel] = useState<any>({});

  ///* store
  const setAlert = useUiStore((s) => s.setAlert);
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog)
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const plans = usePlanStore(s => s.plans)
  const currentUsername = useAuthStore(s => s.user)?.username!

  ///* formulario
  const schemaNewProspectoSchema = useMemo(
    () => newProspectoSchema(valorRestriccionCel),
    [valorRestriccionCel]
  );
  const form = useForm<IFromProspecto>({
    resolver: yupResolver(schemaNewProspectoSchema as any),
    defaultValues: {
      tipo_identificacion: TipoDocumentoNameEnum.RUC,
      es_discapacitado: false,
      pais: NacionalidadEnum.CODIGO,
      nacionalidad: NacionalidadEnum.CODIGO,
      es_curador_tutor: false,
      es_bono_humano: false,
      es_pyme: true,
      residencia_permanente: true
    }
  });

  const {
    reset,
    control,
    setError,
    formState: { errors },
  } = form;

  const createProspectoMutation = usePostProspectoPymes({
    navigate,
    returnUrl: ROUTER_PATHS.ventasPymes.preventaCreateNav
  });

  ///* react query
  const { data: dataPais, isLoading: isLoadingPais } = useFetchGetPais({
    estado: true,
    page_size: 100
  });
  const { mutateAsync: mutateAsyncBuroCredito } = useFetchBuroCredito();
  const { data: dataParamRestriccionCel, isLoading: isLoadingParamRestriccionCel } = useFetchParametros({
    enabled: true,
    params: {
      slug: "RESTRICCION_CELULAR"
    }
  });

  //const { mutateAsync: mutateAsyncSolicitudDeuda } = fetchPostSolicitudDeuda({})

  const searchDataByIdentification = useFetchSearchIdentificationDirecto({
    identificacion: form.watch().identificacion,
    enableSuccessAlert: false,
  });

  /**
   * 
   * Enviar formulario para crear un prospecto
   * 
   * @param data 
   * 
   * @returns 
   */
  const onSubmit = async (data: IFromProspecto) => {

    data.es_pyme = true;

    const resp = await validateSellByOtherUser({ identificacion: data?.identificacion });
    const prospectosInfo = resp?.data;
    if (
      prospectosInfo?.prospectos_corporativos?.length > 0 && prospectosInfo?.prospectos_corporativos?.[0]?.user_create__username != currentUsername 
      || prospectosInfo?.prospectos_pymes?.length > 0 && prospectosInfo?.prospectos_pymes?.[0]?.user_create__username != currentUsername
    ) {
      return setAlert(
        true,
        "El cliente que intentas ingresar corresponde a otro Asesor. Por favor, contacte un Supervisor.",
        AlertSeverityEnum.warning,
        4000
      );
    }

    if (form.getValues().tipo_identificacion === TipoDocumentoNameEnum.RUC
      && form.getValues().estado_contribuyente_ruc == EstadosContribuyenteRucENUM.SUSPENDIDO)
      return setAlert(true, 'Estado contribuyente suspendido', 'error');

    setIsGlobalLoading(true);

    if (!form.getValues().residencia_permanente) {
      setIsGlobalLoading(false);
      setAlert(true, texto.sin_condicion_residencia, AlertSeverityEnum.info);
      return
    }

    if (form.getValues().tipo_identificacion === TipoDocumentoNameEnum.CEDULA) {
      let edad = calcularEdad(data.fecha_nacimiento!);
      if (edad < 18) {
        setIsGlobalLoading(false);
        setAlert(true, texto.edad_no_permitida, AlertSeverityEnum.warning);
        return;
      }

      data.es_tercera_edad = edad >= RangoEdadEnum.EDAD_MAXIMA;
      await createProspectoMutation.mutateAsync(data);

      setIsGlobalLoading(false);
      return;
    }

    if (form.getValues().tipo_identificacion == TipoDocumentoNameEnum.RUC) {
      data.edad = RangoEdadEnum.EDAD_MINIMA;
      await createProspectoMutation.mutateAsync(data)
      setIsGlobalLoading(false);
      return;
    }


  }

  /**
   * Funcion fnBuscarIdentificacion
   * 
   * Realiza una búsqueda asincrónica para obtener información basada en un número de identificación
   * 
   * 202 - Valores pendientes
   * 201 - Es cliente de fibramax
   * 
  */
  const fnBuscarIdentificacion = async (identificacion: string) => {

    try {

      const respRegistroCivil = await searchDataByIdentification.mutateAsync({
        identificacion,
        verificar_cliente: true,
        es_pymes: true
      })
      const data = respRegistroCivil.data

      if (data.estadoContribuyenteRuc == EstadosContribuyenteRucENUM.SUSPENDIDO
        || data.estado_contribuyente_ruc == EstadosContribuyenteRucENUM.SUSPENDIDO) {
        return setAlert(true, 'Estado contribuyente SUSPENDIDO.', AlertSeverityEnum.info)
      }

      ///* Tiene dedudas pendientes por pagar
      /*  if (respRegistroCivil.code === 202) {
 
         let dataDeuda = {
           valorPendiente: 0.00,
           concepto: ''
         }
         if (data.deudas != null) {
           dataDeuda = {
             valorPendiente: Number.parseFloat(data.deudas.at(0)?.pendientePorCobrar ?? '0'),
             concepto: data.deudas?.at(0)?.concepto ?? 'PAGO',
           }
         }
 
         setConfirmDialogIsOpen(true);
         setConfirmDialog({
           isOpen: true,
           title: '¡Valores pendientes!',
           subtitle: `El cliente tiene un deuda pendiente de "$${dataDeuda.valorPendiente.toFixed(2)}" bajo el concepto de "${dataDeuda.valorPendiente}". ¿Deseas enviar la solicitud al supervisor para aprobar el ingreso con deuda?`,
           confirmTextBtn: 'Confirmar',
           onClose() {
             setConfirmDialogIsOpen(false);
           },
           async onConfirm() {
             await mutateAsyncSolicitudDeuda({
               identificacion,
               deuda: dataDeuda.valorPendiente.toFixed(2),
               razon_social: data.razon_social ?? data.razonSocial,
             })
           },
           cancelTextBtn: 'Cerrar',
         })
 
         return
       } */

      ///* Es cliente de Fibramax

      if (respRegistroCivil.code === 201) {
        let planeC = data.planes != null ? data.planes.map(plan => `-${plan.nombre}`).join('\n') : 'N/A';
        setEsCliente({ alerta: true, linea: data.lineas, nombre: data.razon_social, plan: planeC });

        ///* Obtener todos los planes de desarrollo humano o es ayuda social 
        const planBDH = plans.filter(e => e.es_bono_humano || e.es_ayuda_social);
        const codigosArray2 = new Set(planBDH.map(item => item.codigo));

        ///* Verificar si tiene un plan de desarrollo humano o es ayuda social
        const existePlanBDH = data.planes.some(item => codigosArray2.has(item.codigo));


        if (existePlanBDH && respRegistroCivil.linea != 1) {
          setAplicaSolicitudBeneficio(false)
        }

      } else {
        setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });
      }

      form.setValue('linea', respRegistroCivil.linea)

      /* let dataEdad = data.edad;

      if (dataEdad == null) {
        const edad = calcularEdad(data.fecha_nacimiento);
        form.setValue('edad', edad)
        dataEdad = edad;
      }

      if (dataEdad < RangoEdadEnum.EDAD_MINIMA && form.getValues().tipo_identificacion === TipoDocumentoNameEnum.CEDULA)
        setAlert(true, texto.edad_no_permitida, AlertSeverityEnum.warning); */


      setIsGlobalLoading(true);

      ///* Cliente con residencia temporal

      form.setValue('residencia_permanente', true)


      ///* venta con cedula

      /* if (identificacion.length === 10) {
        const paisInfo = dataPais?.data.data.find(e => e.nacionalidad == data.nacionalidad);
        reset({
          ...form.getValues(),
          fecha_nacimiento: data.fecha_nacimiento,
          razon_social: data.razon_social,
          edad: dataEdad,
          nacionalidad: paisInfo?.codigo || '',
          pais: paisInfo?.codigo || ''
        })
        dataEdad >= RangoEdadEnum.EDAD_MAXIMA && setAlert(true, texto.persona_tercera_edad, 'info');
      } */

      ///* venta con RUC
      if (identificacion.length === 13) {
        form.setValue('residencia_permanente', true)

        reset({
          ...form.getValues(),
          edad: 99,
          nacionalidad: NacionalidadEnum.CODIGO,
          pais: NacionalidadEnum.CODIGO,
          razon_social: data.razonSocial,
          tipo_contribuyente: data.tipoContribuyente || data.tipo_contribuyente,
          estado_contribuyente_ruc: data.estadoContribuyenteRuc || data.estado_contribuyente_ruc,
          regimen: data.regimen,
          actividad_economica_principal: data.actividadEconomicaPrincipal
        })
      }

      if (VITE_NODE_ENV == 'prod') {
        const respBuroCredito = await mutateAsyncBuroCredito({
          identificacion
        });
        reset({
          ...form.getValues(),
          segmentacion: respBuroCredito.data.segmentacion,
          puntaje_score_empresa: respBuroCredito.data.puntaje_score_empresa,
          puntaje_score: respBuroCredito.data.puntaje_score,
          puntaje_score_sobreendeudamiento: respBuroCredito.data.puntaje_score_sobreendeudamiento,
        })
      } else {
        reset({
          ...form.getValues(),
          segmentacion: "DATA TEST",
          puntaje_score_empresa: 999,
          puntaje_score: 999,
          puntaje_score_sobreendeudamiento: 999,
        })
      }

    } catch (error) {

      //handleAxiosError(error)

      if (isAxiosError(error)) {

        const respError: any = error.response?.data || {};

        if (respError === 408) return setEsDifunto(true);

        if (respError.code == 407
          || respError.code == 406
          || respError.code == 500
          || error.code == 'ERR_NETWORK'
          || error.code == 'ERR_BAD_RESPONSE') {
          setConfirmDialogIsOpen(true);
          setConfirmDialog({
            isOpen: true,
            title: '¡Problemas al consultar en Registro Civil!',
            subtitle: `Los servicios de consulta no están disponibles en este momento. Mientras tanto, puedes ingresar los datos manualmente.`,
            confirmTextBtn: 'Confirmar',
            onClose() {
              setConfirmDialogIsOpen(false);
            },
            async onConfirm() {

              const respBuroCredio = await mutateAsyncBuroCredito({
                identificacion
              });

              reset({
                ...form.getValues(),
                segmentacion: respBuroCredio.data.segmentacion,
                puntaje_score_empresa: respBuroCredio.data.puntaje_score_empresa,
                puntaje_score: respBuroCredio.data.puntaje_score,
                puntaje_score_sobreendeudamiento: respBuroCredio.data.puntaje_score_sobreendeudamiento,
                nacionalidad: NacionalidadEnum.CODIGO,
                pais: NacionalidadEnum.CODIGO,
              })

              setConfirmDialogIsOpen(false);
              setEsResidente(true);
              form.setValue('residencia_permanente', true)
              //setcheckedResidencia(true);
            },
            cancelTextBtn: 'Cerrar',
          });
          return;
        }

        ///* Tiene una venta en proceso
        if (respError?.code == 409) {

          setConfirmDialogIsOpen(true);

          setConfirmDialog({
            isOpen: true,
            title: '¡Prospecto!',
            subtitle:
              'Existe un prospecto EN PROCESO de gestión. Por favor, comunícate con tu asesor para obtener más información.',
            onConfirm() {
              setConfirmDialogIsOpen(false);
            },
            confirmTextBtn: 'Cerrar',
          });

          return;
        }

      } else {
        //handleAxiosError(error)
      }

    } finally {
      setIsGlobalLoading(false);

    }
  }


  const handleBuscarIdentificacion = async(aux: string) => {
    // reset({ ...form.getValues(), identificacion: aux });
    form.setValue("identificacion", aux);
    if(aux?.length == 13 && form.getValues().tipo_identificacion == TipoDocumentoNameEnum.RUC){

      setEsDifunto(false)
      setEsResidente(false)
      setAplicaSolicitudBeneficio(true)
      setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' })

      const resp = await validateSellByOtherUser({ identificacion: aux });
      const prospectosInfo = resp?.data;
      if (
        prospectosInfo?.prospectos_corporativos?.length > 0 && prospectosInfo?.prospectos_corporativos?.[0]?.user_create__username != currentUsername 
        || prospectosInfo?.prospectos_pymes?.length > 0 && prospectosInfo?.prospectos_pymes?.[0]?.user_create__username != currentUsername
      ) {
        return setAlert(
          true,
          "El cliente que intentas ingresar corresponde a otro Asesor. Por favor, contacte un Supervisor.",
          AlertSeverityEnum.warning,
          4000
        );
      }


      setIsGlobalLoading(true);
      fnBuscarIdentificacion(aux);
      reset({ ...form.getValues(), identificacion: aux });
      setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });

    }
    


    // if (aux) {
    //   switch (form.getValues().tipo_identificacion) {
    //     case TipoDocumentoNameEnum.CEDULA:
    //       if (aux?.length == 10) {
    //         //const isValid = validateEcuadorianID(form.getValues().identificacion);
    //         //if (!isValid) return setAlert(true, 'La cédula que ingreso no es valida', AlertSeverityEnum.warning);
    //         reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: aux });
    //         setIsGlobalLoading(true);
    //         fnBuscarIdentificacion(aux);
    //         return;
    //       }
    //       reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: aux });
    //       setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });
    //       break;

    //     case TipoDocumentoNameEnum.RUC:
    //       if (aux?.length == 13) {
    //         reset({ ...form.getValues(), identificacion: aux });
    //         setIsGlobalLoading(true);
    //         fnBuscarIdentificacion(aux);
    //         return;
    //       }
    //       reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: aux });
    //       setEsCliente({ alerta: false, linea: undefined, nombre: '', plan: '' });
    //       break;
    //     default:
    //       reset({ tipo_identificacion: form.getValues().tipo_identificacion })
    //       setEsResidente(false);
    //       form.setValue('residencia_permanente', false)
    //       //setcheckedResidencia(true);
    //       break;
    //   }
    //   return;
    // }

    // reset({ tipo_identificacion: form.getValues().tipo_identificacion, identificacion: '', residencia_permanente: false, })
  }



  useEffect(() => {
    if (!isLoadingParamRestriccionCel) {
      setValorRestriccionCel(
        dataParamRestriccionCel?.data?.data?.[0]?.valor 
        ? JSON.parse(dataParamRestriccionCel?.data?.data?.[0]?.valor) 
        : {}
      );
    }
  }, [isLoadingParamRestriccionCel, dataParamRestriccionCel])



  return {

    //state
    esDifunto,
    setEsDifunto,
    esCliente,
    setEsCliente,
    calcularEdad,

    setDisableIdentification,
    disableIdentification,
    setAlert,
    setIsGlobalLoading,
    setEsResidente,
    esResidente,
    isLoadingPais,
    dataPais: dataPais?.data.data,

    //dataProspectoEnEspera,
    //dataProspectoEnProceso,

    setModalProspectoEnEspera,
    modalProspectoEnEspera,
    setModalProspectoEnProceso,
    modalProspectoEnProceso,

    //form
    form,
    control,
    reset,
    errors,
    setError,

    //fn
    onSubmit,
    fnBuscarIdentificacion,

    ///*Carga de imagenes para beneficio
    UploadImageComponent,
    fotoTutorDiscapacidad,
    setFotoTutorDiscapacidad,
    fotoDocumentoLegalRepresentante,
    setFotoDocumentoLegalRepresentante,
    fotoBonoDesarrolloHumano,
    setFotoBonoDesarrolloHumano,

    ///*
    aplicaSolicitudBeneficio,
    setAplicaSolicitudBeneficio,
    handleBuscarIdentificacion,
    valorRestriccionCel
  }
}